import React, { useState, useEffect } from "react";
import { FaArrowAltCircleDown, FaArrowAltCircleUp } from 'react-icons/fa';
import DropdownINV from "./DropdownINV";
import './DropdownCT.css';

function DropdownCT(props) {
    const { idCT, invArray, colorCT, nombreCT } = props;
    const [ displayINV, setDisplayINV ] = useState( 'none' );
    const [ icono, setIcono ] = useState(<FaArrowAltCircleDown size={25} color={'white'}/>);

    var html;
    for (var i = 0; i < invArray.length; i++){
        html = <>{html} <div style={{display:displayINV}}><DropdownINV idCT={idCT} idINV={invArray[i].idInverter} nombreINV={invArray[i].nameInverter} colorINV={invArray[i].color}/></div></>
    }

    function handleClickCT(){
        if ( displayINV === 'none' ){
            setDisplayINV('block');
            setIcono(<FaArrowAltCircleUp size={25} color={'white'}/>);
        } else {
            setDisplayINV('none');
            setIcono(<FaArrowAltCircleDown size={25} color={'white'}/>);
        }
    }


    //Deshabilitar el link si no hay pantalla de ct
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "CT");
    const [hrefDisabled,setHrefDisabled] = useState(<></>);

    useEffect(() => {
        if(screen[0].Enabled === false){
            setHrefDisabled(<div className="ct-word">{nombreCT}</div>)
        }else{
            setHrefDisabled(<div className="ct-word" onClick={() => { window.open("/#/ct/" + idCT, "_self")}}>{nombreCT}</div>)
        }
    },[]);


    return(
        <div>
            <div className="div-ct-complete" style={{backgroundColor: colorCT}}>
                {hrefDisabled}
                <div className="arrow-ct" onClick={handleClickCT}>{icono}</div>
            </div>
            {html}
        </div>
    );
}

export default DropdownCT